import "./style/CSSreset.css"
import "./style/app.css"
import { Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { Quiz } from "./pages/Quiz";
import { Results } from "./pages/Results";
import { Settings } from "./pages/Settings";

function App() {
  return (
    <Routes>
      <Route index element={<Home />}/>
      <Route path="quiz" element={<Quiz />}/>
      <Route path="results" element={<Results />}/>
      <Route path="settings" element={<Settings />}/>
    </Routes>
  );
}

export default App;
